/*
 Created by CHT 2019/12/4 10:10
*/
import {
  CHART_TYPE__CALENDAR, CHART_TYPE__CONTAINER_CHART,
  CHART_TYPE__DATA,
  CHART_TYPE__DETAILED,
  CHART_TYPE__FILTER_BTN,
  CHART_TYPE__FILTER_CONTROL, CHART_TYPE__FLOW_CHART,
  CHART_TYPE__MEDIA_CHART, CHART_TYPE__SHORTCUT_CHART,
  CHART_TYPE__STATISTICS,
  CHART_TYPE__TEXT, CHART_TYPE__TODO_CHART
} from "./types"
import instances from './instances/index'
import {clone, isEmpty, isObject} from "../../assets/js/Untis"
import Statistics from "./instances/Statistics";
import BaseChart from "./BaseChart";

class RyDashBoard {
  constructor() {

    // 编辑中的chart
    this.editingItem = null

    // 是否初始化
    this.isInit = false
    // 是否修改过
    this.edited = false


    this.userId = null
    this.companyId = null
    this.appId = null
    this.dashboardId = null

    // 仪表盘名称
    this.dashboardName = ''
    // 备注
    this.remark = ''
    // 仪表盘外链名称
    this.queryTitle = ''

    this.children = []

    this.isLink = false // 当前仪表盘是否是在外链环境

    this.styles = {
      theme: {
        "name": "preset_style_tint",
        "highLightColor": "#05A971",
        "palette": "preset_1"
      },
      background: {
        "type": "color",
        "color": "#F4F6F9",
        "image": "",
        "position": "center"
      },
      widget: {
        "colorInfo": {
          "titleColor": "#1F2D3D",
          "contentColor": "rgba(159, 166, 175, 1)",
          "colorGradation": "preset_map_1",
          "colorCardId": "0"
        },
        "background": {
          "type": "color",
          "color": "#FFFFFF",
          "image": "",
          "position": "center"
        },
        "tableSetting": {
          "themeColor": "rgba(233, 237, 242, 1)",
          "headColor": "rgba(122, 128, 136, 1)",
          "textColor": "rgba(65, 68, 72, 1)",
          "textAlign": "left"
        }
      },
      filterEmptyLoadData: 'YES'
    }
  }

  get chartList() {
    return this.children
  }

  set chartList(list) {
    this.children.splice(0, this.children.length)
    list.forEach(info => {
      const item = this.createItem(info.chartType)
      this.addItem(item).setBase(info)
    })
  }

  get menu() {
    const chartTypes = this.children.map(chart => chart.chartType)

    return [
      {
        label: '图表控件',
        children: [
          {
            label: '统计表',
            chartType: CHART_TYPE__STATISTICS,
            disabled: false
          },
          {
            label: '明细表',
            chartType: CHART_TYPE__DETAILED,
            disabled: false
          },
          {
            label: '数据表格控件',
            chartType: CHART_TYPE__DATA,
            disabled: false
          },
          {
            label: '日历',
            chartType: CHART_TYPE__CALENDAR,
            disabled: false
          }
        ]
      },
      {
        label: '筛选控件',
        children: [
          {
            label: '筛选器',
            chartType: CHART_TYPE__FILTER_CONTROL,
            disabled: false
          },
          {
            label: '筛选按钮',
            chartType: CHART_TYPE__FILTER_BTN,
            disabled: !chartTypes.includes(CHART_TYPE__FILTER_CONTROL) || chartTypes.includes(CHART_TYPE__FILTER_BTN)
          }
        ]
      },
      {
        label: '展示控件',
        chartType: CHART_TYPE__CONTAINER_CHART,
        disabled: false
      },
      {
        label: '其他控件',
        children: [
          {
            label: '文字控件',
            chartType: CHART_TYPE__TEXT,
            disabled: false
          },
          {
            label: '快捷方式',
            chartType: CHART_TYPE__SHORTCUT_CHART,
            disabled: false
          },
          {
            label: '待我处理',
            chartType: CHART_TYPE__TODO_CHART,
            disabled: false
          },
          {
            label: '我的流程',
            chartType: CHART_TYPE__FLOW_CHART,
            disabled: false
          },
        ]
      },

      // {
      //   label: '富媒体控件',
      //   chartType: CHART_TYPE__MEDIA_CHART,
      //   disabled: false
      // }
    ]
  }
}

RyDashBoard.instancesMap = (() => {
  const obj = {}
  Object.values(instances).forEach(item => {
    obj[item.type] = item
  })
  return obj
})()

RyDashBoard.prototype.themeOptional = [
  {
    id: "0",
    name: '经典',
    value: [
      '#63B2EE',
      '#76DA91',
      '#F8CB7F',
      '#F89588',
      '#7CD6CF',
      '#9192AB',
      '#7898E1',
      '#EFA666',
      '#EDDD86',
      '#9987CE'
    ]
  },
  {
    id: "1",
    name: '炽热',
    value: [
      'rgb(236, 95, 2)',
      'rgb(255, 155, 59)',
      'rgb(214, 167, 124)',
      'rgb(182, 24, 4)',
      'rgb(138, 19, 1)',
      'rgb(65, 142, 193)',
      'rgb(254, 204, 214)',
      'rgb(247, 98, 105)',
      'rgb(229, 91, 95)',
      'rgb(225, 76, 94)'
    ]
  },
  {
    id: "2",
    name: '希望',
    value: [
      'rgb(73, 93, 158)',
      'rgb(177, 198, 223)',
      'rgb(218, 246, 140)',
      'rgb(180, 219, 63)',
      'rgb(123, 171, 23)',
      'rgb(84, 125, 21)',
      'rgb(254, 247, 98)',
      'rgb(247, 220, 48)',
      'rgb(211, 192, 79)',
      'rgb(134, 123, 90)'
    ]
  },
  {
    id: "3",
    name: '质感',
    value: [
      'rgb(135, 213, 239)',
      'rgb(105, 197, 230)',
      'rgb(73, 110, 208)',
      'rgb(187, 137, 238)',
      'rgb(108, 67, 170)',
      'rgb(81, 143, 165)',
      'rgb(55, 67, 84)',
      'rgb(82, 85, 159)',
      'rgb(166, 88, 186)',
      'rgb(188, 119, 206)'
    ]
  },
  {
    id: "4",
    name: '海滩',
    value: [
      'rgb(255,155,136)',
      'rgb(91,212,214)',
      'rgb(116,161,247)',
      'rgb(255, 213, 67)',
      'rgb(204, 216, 226)',
      'rgb(142, 114, 192)',
      'rgb(64, 129, 190)',
      'rgb(167, 226, 233)',
      'rgb(145, 185, 255)',
      'rgb(54, 83, 115)'
    ]
  },
  {
    id: "5",
    name: '现代',
    value: [
      'rgb(255 ,132,0)',
      'rgb(255, 224, 90)',
      'rgb(43, 118, 212)',
      'rgb(0, 204, 173)',
      'rgb(255, 167, 0)',
      'rgb(0, 177, 204)',
      'rgb(94, 88, 213)',
      'rgb(26, 230, 133)',
      'rgb(249, 206, 58)',
      'rgb(37, 117, 108)'
    ]
  },
  {
    id: "6",
    name: '春天',
    value: [
      'rgb(157, 217, 115)',
      'rgb(91, 217, 217)',
      'rgb(242, 176, 94)',
      'rgb(242, 237, 162)',
      'rgb(242, 107, 131)',
      'rgb(178, 167, 217)',
      'rgb(242, 233, 102)',
      'rgb(73, 191, 158)',
      'rgb(242, 131, 107)',
      'rgb(133, 182, 242)'
    ]
  },
  {
    id: "7",
    name: '夏天',
    value: [
      'rgb(0, 166, 239)',
      'rgb(0, 82, 151)',
      'rgb(48, 222, 192)',
      'rgb(167, 226, 233)',
      'rgb(64, 129, 190)',
      'rgb(204, 216, 226)',
      'rgb(54, 83, 115)',
      'rgb(0, 196, 175)',
      'rgb(193, 218, 240)',
      'rgb(37, 154, 141)'
    ]
  },
  {
    id: "8",
    name: '秋天',
    value: [
      'rgb(178, 191, 89)',
      'rgb(242, 157, 56)',
      'rgb(236, 212, 141)',
      'rgb(110, 167, 64)',
      'rgb(235, 197, 130)',
      'rgb(165, 112, 81)',
      'rgb(117, 205, 98)',
      'rgb(242, 211, 127)',
      'rgb(212, 160, 130)',
      'rgb(100, 222, 200)'
    ]
  },
  {
    id: "9",
    name: '冬天',
    value: [
      'rgb(255, 170, 170)',
      'rgb(120, 155, 242)',
      'rgb(115, 221, 195)',
      'rgb(250, 203, 124)',
      'rgb(255, 168, 225)',
      'rgb(168, 189, 239)',
      'rgb(125, 222, 198)',
      'rgb(244, 214, 161)',
      'rgb(255, 200, 170)',
      'rgb(190, 175, 255)'
    ]
  },
]

RyDashBoard.prototype.colorGradationOpts = [
  {
    label: '天空',
    value: 'preset_map_1',
    startColor: '#B5E9F5',
    endColor: '#0361E5',
    color: 'linear-gradient(to right, rgb(181, 233, 245) 0%, rgb(3, 97, 229) 100%)'
  },
  {
    label: '柠檬',
    value: 'preset_map_2',
    startColor: '#FFF9E3',
    endColor: '#B58D02',
    color: 'linear-gradient(to right, rgb(255, 249, 227) 0%, rgb(181, 141, 2) 100%)'
  },
  {
    label: '薰衣草',
    value: 'preset_map_3',
    startColor: '#F4E9FE',
    endColor: '#7531AC',
    color: 'linear-gradient(to right, rgb(244, 233, 254) 0%, rgb(117, 49, 172) 100%)'
  },
  {
    label: '森林',
    value: 'preset_map_4',
    startColor: '#E3F5DA',
    endColor: '#174700',
    color: 'linear-gradient(to right, rgb(227, 245, 218) 0%, rgb(23, 71, 0) 100%)'
  },
  {
    label: '日光',
    value: 'preset_map_7',
    startColor: '#DFECC1',
    endColor: '#E9272B',
    color: 'linear-gradient(to right, rgb(223, 236, 193) 0%, rgb(233, 39, 43) 100%)'
  },
  {
    label: '大海',
    value: 'preset_map_5',
    startColor: '#E4F7FF',
    endColor: '#0B5F83',
    color: 'linear-gradient(to right, rgb(228, 247, 255) 0%, rgb(11, 95, 131) 100%)'
  },
  {
    label: '薄荷',
    value: 'preset_map_6',
    startColor: '#A4EBB3',
    endColor: '#04BAF3',
    color: 'linear-gradient(to right, rgb(164, 235, 179) 0%, rgb(4, 186, 243) 100%)'
  },
]

RyDashBoard.prototype.gradationMap = {
  'preset_map_1': {
    startColor: '#B5E9F5',
    endColor: '#0361E5',
    color: 'linear-gradient(to right, rgb(181, 233, 245) 0%, rgb(3, 97, 229) 100%)'
  },
  'preset_map_2': {
    startColor: '#FFF9E3',
    endColor: '#B58D02',
    color: 'linear-gradient(to right, rgb(255, 249, 227) 0%, rgb(181, 141, 2) 100%)'
  },
  'preset_map_3': {
    startColor: '#F4E9FE',
    endColor: '#7531AC',
    color: 'linear-gradient(to right, rgb(244, 233, 254) 0%, rgb(117, 49, 172) 100%)'
  },
  'preset_map_4': {
    startColor: '#E3F5DA',
    endColor: '#174700',
    color: 'linear-gradient(to right, rgb(227, 245, 218) 0%, rgb(23, 71, 0) 100%)'
  },
  'preset_map_5': {
    startColor: '#E4F7FF',
    endColor: '#0B5F83',
    color: 'linear-gradient(to right, rgb(228, 247, 255) 0%, rgb(11, 95, 131) 100%)'
  },
  'preset_map_6': {
    startColor: '#A4EBB3',
    endColor: '#04BAF3',
    color: 'linear-gradient(to right, rgb(164, 235, 179) 0%, rgb(4, 186, 243) 100%)'
  },
  'preset_map_7': {
    startColor: '#DFECC1',
    endColor: '#E9272B',
    color: 'linear-gradient(to right, rgb(223, 236, 193) 0%, rgb(233, 39, 43) 100%)'
  }
}

RyDashBoard.init = function (opts = {}) {
  const {
    userId = null,
    dashboardId = null,
    companyId = null,
    appId = null,
    dashboardName = '',
    remark = ''
  } = opts
  const dashBoard = new RyDashBoard()
  dashBoard.companyId = companyId
  dashBoard.userId = userId
  dashBoard.appId = appId
  dashBoard.dashboardId = dashboardId
  dashBoard.dashboardName = dashboardName
  dashBoard.remark = remark
  return dashBoard
}
RyDashBoard.createDashboard = function (opts) {
  const dashBoard = RyDashBoard.init(opts)
  dashBoard.dashboardName = opts.dashboardName || ''
  dashBoard.remark = opts.remark || ''
  return dashBoard
}
RyDashBoard.childrenTypes = [
  CHART_TYPE__STATISTICS,
  CHART_TYPE__DETAILED,
  CHART_TYPE__DATA,
  CHART_TYPE__CALENDAR,
  CHART_TYPE__TEXT,
  CHART_TYPE__FILTER_CONTROL,
  CHART_TYPE__MEDIA_CHART,
  CHART_TYPE__SHORTCUT_CHART,
  CHART_TYPE__TODO_CHART,
  CHART_TYPE__FLOW_CHART,
  CHART_TYPE__CONTAINER_CHART
]

// 该根据不同的状态 会被新的函数覆盖 用以让下级图表请求数据请求数据
RyDashBoard.prototype.chartDataPreviewFun = () => {
}

// 导出数据 会被新的函数覆盖 用以让下级图表请求数据请求数据
RyDashBoard.prototype.chartDataExportData = () => {
}

RyDashBoard.prototype.getConf = function () {
  return {
    userId: this.userId,
    companyId: this.companyId,
    appId: this.appId,
    dashboardId: this.dashboardId,
    dashboardName: this.dashboardName,
    chartList: this.chartList,
    remark: this.remark,
    styles: this.styles
  }
}
RyDashBoard.prototype.setConf = function (opts) {

  const keys = [
    'userId',
    'companyId',
    'appId',
    'dashboardId',
    'dashboardName',
    'chartList',
    'remark',
    'queryTitle',
    'styles'
  ]

  keys.forEach(key => {
    if (opts[key]) {
      if (key === 'styles') {
        if (Object.keys(opts[key]).length) this[key] = opts[key]
      } else {
        this[key] = opts[key]
      }
    }
  })

  this.edited = false
}


RyDashBoard.prototype.getChartList = function () {
  return this.chartList.map(chart => {
    if (chart.getConf) {
      return {
        ...chart.getConf(),
        ...chart.getBase()
      }
    } else {
      return {
        ...chart.getBase()
      }
    }
  })
}

// 添加新图表时 计算新图表的 基本位置
RyDashBoard.prototype.newlyTop = function () {
  if (this.children.length) {
    return Math.max(...this.children.map(item => item.y + item.h))
  } else {
    return 0
  }
}
RyDashBoard.prototype.newlyLeft = function () {
  let current = null
  this.children.forEach(item => {
    if (current === null) {
      current = item
    } else if (item.y > current.y) {
      current = item
    } else if (item.y === current.y && item.x > current.x) {
      current = item
    }
  })
  return current ? current.x + current.w : 0
}

// 创建图表
RyDashBoard.prototype.createItem = function (chartType) {
  return new RyDashBoard.instancesMap[chartType]()
}
RyDashBoard.prototype.addItem = function (item) {
  let x = this.newlyLeft()
  let y = this.newlyTop()

  if (x + item.w > 60) {
    x = 0
  }
  item.y = y
  item.x = x
  item.parent = this

  this.children.push(item)
  return item
}

// 获取各个图表的数据
RyDashBoard.prototype.getChartValue = async function (needLoading = true) {
  const chartMap = {}

  await Promise.all(
    this.children
      .filter(chart => chart.chartType === CHART_TYPE__FILTER_CONTROL)
      .map(filterControl => {
        return filterControl.getChartValue()
      })
  )


  this.children
    .filter(chart => chart.chartType === CHART_TYPE__FILTER_CONTROL)
    .forEach(filterControl => {
      const holder = filterControl.chartPropertiesHolder
      Object.keys(holder.chartFilterMap).forEach(chartId => {
        const filterConf = holder.chartFilterMap[chartId]
        const chartCondition = chartMap[chartId] ?
          chartMap[chartId] :
          chartMap[chartId] = []

        if (filterControl.value.method) {
          chartCondition.push({
            type: "",
            method: filterControl.value.method,
            value: filterControl.value.value,
            fieldId: filterConf.dataId,
            fixedValue: filterControl.value.fixedValue,
            extValue: filterControl.value.extValue
          })
        }
      })
    })

  return Promise.all(
    this.children
      .filter(chart => chart && chart.getValue)
      .map(chart => {
        if (chartMap[chart.chartId]) {
          // const holder = clone(chart.chartPropertiesHolder)
          // holder.filter.conditionList.push(...chartMap[chart.chartId])
          let filter = {
            relation: "and",
            notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
            conditionList: []
          }
          filter.conditionList.push(...chartMap[chart.chartId])
          return chart.getValue({
            // chartPropertiesHolder: holder
          }, filter, false, needLoading)
        } else {
          return chart.getValue({}, null, false, needLoading)
        }
      })
  )
}
RyDashBoard.prototype.getChartMap = function () {
  const map = {}
  this.children.forEach(chart => {
    map[chart.chartId] = chart
  })
  return map
}
RyDashBoard.prototype.submitFilter = function (filterChart = null) {

  // 当前仪表盘的所有 chart 的 chartType
  const chartTypes = this.children.map(chart => chart.chartType)
  const allChartMap = this.getChartMap()
  const chartMap = {}
  const filterControlList = []

  // if (chartTypes.includes(CHART_TYPE__FILTER_BTN) && filterChart === null) {
    // 筛选按钮按下时触发
    this.children
      .filter(chart => chart.chartType === CHART_TYPE__FILTER_CONTROL)
      .forEach(filterControl => {
        filterControlList.push(filterControl)
        const holder = filterControl.chartPropertiesHolder
        Object.keys(holder.chartFilterMap).forEach(chartId => {
          const filterConf = holder.chartFilterMap[chartId]
          const chartCondition = chartMap[chartId] ?
            chartMap[chartId] :
            chartMap[chartId] = []
          if (filterControl.value.method) {
            chartCondition.push({
              type: "",
              method: filterControl.value.method,
              value: filterControl.value.value,
              fieldId: filterConf.dataId,
              fixedValue: filterControl.value.fixedValue,
              extValue: filterControl.value.extValue
            })
          }
        })
      })

  // } else if (filterChart) {
  //   filterControlList.push(filterChart)
  //   const holder = filterChart.chartPropertiesHolder
  //   filterChart.isLoad = false
  //   // 1、先找出筛选器关联的图表
  //   Object.keys(holder.chartFilterMap).forEach(chartId => {
  //     // const filterConf = holder.chartFilterMap[chartId]
  //     const chartCondition = chartMap[chartId] ?
  //       chartMap[chartId] :
  //       chartMap[chartId] = []
  //     // if (filterChart.value.method) {
  //     //   chartCondition.push({
  //     //     type: "",
  //     //     method: filterChart.value.method,
  //     //     value: filterChart.value.value,
  //     //     fieldId: filterConf.dataId,
  //     //     fixedValue: filterChart.value.fixedValue
  //     //   })
  //     // }
  //
  //     // 2、遍历所有筛选器
  //     this.children
  //       .filter(chart => chart.chartType === CHART_TYPE__FILTER_CONTROL)
  //       .forEach(filterControl => {
  //         const holder = filterControl.chartPropertiesHolder
  //         // 3、找出图表关联的所有筛选器
  //         const filterConf = holder.chartFilterMap[chartId]
  //
  //         if (filterConf && filterControl.value.method) {
  //           chartCondition.push({
  //             type: "",
  //             method: filterControl.value.method,
  //             value: filterControl.value.value,
  //             fieldId: filterConf.dataId,
  //             fixedValue: filterControl.value.fixedValue,
  //             extValue: filterControl.value.extValue
  //           })
  //         }
  //       })
  //   })
  // }

  filterControlList.forEach(filterControl => {
    filterControl.isLoad = false
  })

  return Promise.all(
    Object.keys(chartMap).map(chartId => {
      const chart = allChartMap[chartId]
      // const holder = clone(chart.chartPropertiesHolder)
      // holder.filter.conditionList.push(...chartMap[chartId])
      if (chart) {
        let filter = {
          relation: "and",
          notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
          conditionList: []
        }
        filter.conditionList.push(...chartMap[chart.chartId])
        return chart.getValue({
          // chartPropertiesHolder: holder
        }, filter)
      }
    })
  ).catch(err => {
    console.error(err)
  }).finally(() => {
    filterControlList.forEach(filterControl => {
      filterControl.isLoad = true
    })
  })
}

RyDashBoard.prototype.copyDash = function () {

  const dash = RyDashBoard.init({
    userId: this.userId,
    formId: this.formId,
    companyId: this.companyId,
    appId: this.appId,
    dashboardId: this.dashboardId,
    dashboardName: this.dashboardName,
    remark: this.remark
  })


  dash.setConf({
    ...this.getConf(),
    chartList: this.children.map(item => item.getBase())
  })
  dash.isInit = true
  return dash
}
export default RyDashBoard
